var Theme = {
  
  debug: { console: false },
  
  initialize: function() {
    //
    // Debug
    if (Theme.debug.console) console.log("Initializing the theme...");
    //
    Theme.bind();
  },
  
  bind: function() {
    //
    // Debug
    if (Theme.debug.console) console.log("Binding theme events...");
    //
		
		/*
			On page load or window resize, set height of main slide to window height
		*/
    Theme.setMainSlide();
		$(window).resize(function() { Theme.setMainSlide(); });
		
		/*
			On imagesLoaded, fade in page elements
		*/
		$(".product-collage").imagesLoaded(
			function(){ $(".product-collage").addClass("loaded"); }
		);
		
		$(".product-details").imagesLoaded(
			function(){ $(".product-details").addClass("loaded"); }
		);
		
		/*
			On mouseover/out, show or hide the header dropdowns
		*/
    
		$(".customer-menu").hoverIntent(
			function() { Theme.toggleNav(this); },
			function() { Theme.toggleNav(this); }
		);
		
		/*
			On mouseover/out, highlight product in homepage collage
		*/
		$(".product-collage .link a").hoverIntent(
			function() { Theme.productCollage(this); },
			function() { Theme.productCollage(this); }
		);
		
		/*
			On click, change product ingredients
		*/
		$(".product-ingredients nav li").on("click",
			function(event) {
				event.preventDefault();
				if(!$(this).hasClass("active")) Theme.switchIngredientsTab($(this).index());
			}
		);
		
		/*
			On click, scrollTo product ingredients
		*/
		$(".product-icon > a").on("click",
			function(event) {
				event.preventDefault();
				$.scrollTo($(".product-ingredients"),750);
			}
		);
		
		/*
			On click, toggle press article size
		*/
		$("article.press .press-description").on("click",
			function() { Theme.togglePressArticle(this); }
		);
		$("article.press .large-image a").on("click",
			function() { $(this).parent().fadeOut(); }
		);
  },
	
  setMainSlide: function(element, offset) {
    $(".main-slide").css("min-height", window.innerHeight+'px');
  },
	
	toggleNav: function(el) {
    //
    // Debug
    if (Theme.debug.console) console.log("Toggle navigation...");
    //
		var menu = $(el).find("ul:first");
		if (menu.is(":visible")) menu.fadeOut(325);
		else menu.fadeIn(325);
	},
	
	productCollage: function(el) {
    //
    // Debug
    if (Theme.debug.console) console.log("Toggle active product...");
    //
		var activeProduct = $(el).closest(".link"),
				dataContent = activeProduct.attr("data-content"),
				adjustInactive = function() {
					$(".product-collage .link > img.mask")
						.not(activeProduct.find("img.mask"))
						.toggleClass("opaque");
				},
				setClass = function() {
					if (activeProduct.hasClass("selected")) {
						activeProduct.parent().find(".overlay").fadeOut(
							325, function() { 
								activeProduct.removeClass("selected");
								$(".product-collage .link").removeClass("hide-icon");
							});
					}
					else {
						activeProduct.addClass("selected");
						$(".product-collage .link").not(activeProduct).addClass("hide-icon");
						activeProduct.parent().find(".overlay[data-content="+dataContent+"]").fadeIn(325);
					}
				};
		adjustInactive();
		setClass();
	},
	
	switchIngredientsTab: function(index) {
    //
    // Debug
    if (Theme.debug.console) console.log("Switching product ingredients tab...");
    //
		var tabs = $(".product-ingredients .tab-group .tab"),
				fadeInTabs = function() {
					tabs.eq(index).fadeIn();
				};
		$(tabs).fadeOut(
			325,
			function() {
				$(".product-ingredients nav .active").removeClass("active");
				$(".product-ingredients nav li").eq(index).addClass("active");
				_.delay(fadeInTabs, 500);
			}
		);
	},
	
	togglePressArticle: function(el) {
    //
    // Debug
    if (Theme.debug.console) console.log("Toggling size of press article...");
    //
		$(".large-image:visible").fadeOut();
		$(el).parent().find(".large-image").fadeIn();
	}
};